import { Directive, ElementRef } from '@angular/core';
import { AppState } from '../../config/state';

/**
 * Generated class for the CoHideBackButtonDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[co-hide-back-button]' // Attribute selector
})
export class CoHideBackButtonDirective {
  backButton: any;

  constructor(private el: ElementRef, private state: AppState) {
    
  }

  ngOnInit() {
    if (this.state.sharedScreen) {
      this.backButton = this.el.nativeElement.querySelector('.back-button');
      this.backButton.classList.add('displayNone');
      this.backButton.classList.add('bringToFront');
    }
  }

}



// WEBPACK FOOTER //
// ./src/directives/co-hide-back-button/co-hide-back-button.ts